import { apiUrl } from './config';
import { getAccessToken } from './authConfig';
const signalR = require('@microsoft/signalr');

export var deviceHub;

export const buildSignalRHub = () => {
	deviceHub = new signalR.HubConnectionBuilder()
		.withUrl(`${apiUrl}/hubs/userhub`, {
			// accessTokenFactory may return a Promise — the SDK hands back a
			// cached token or silently refreshes, so each (re)connect uses a valid
			// token for the current org context.
			accessTokenFactory: () => getAccessToken(),
		})
		.withAutomaticReconnect()
		.build();
};
